import styled from 'styled-components';

export const UnitRow = styled.div`
  display: flex;

  > * {
    display: inline-block;
  }

  div {
    flex: 1;
    display: flex;
    cursor: pointer;

    > * {
      display: inline-block;
    }

    .name {
      flex: 1;
    }
  }

  i {
    line-height: 1.5;
  }
`;
